import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  getList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/findlist`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getDetail ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/findDetailById`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveLecture ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/save`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteLecture ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/orderDelete`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrgId ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get(`/org/findBusinessNameById`, { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  approval ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/approveStart`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportApplication ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/coursePaid/exportList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getReportList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/findReportList`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportReport ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/coursePaid/exportReportList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getCourseList ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/findListForOrder`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  nullifyLecture ({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`/coursePaid/orderCancel`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
